import { UpperCasePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterOutlet } from '@angular/router'

import { HlmToasterComponent } from '@yoshu-lib/ui/ui-sonner-helm/src'

import { PosthogService } from '@yoshu-lib/core/posthog/posthog.service'

import { environment } from '../environments/environment'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HlmToasterComponent, UpperCasePipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title)

  readonly currentEnvironment = environment.name
  title = 'demo'

  constructor(posthogService: PosthogService) {}

  ngOnInit() {
    if (this.currentEnvironment !== 'production') {
      const currentDocumentTitle = this.titleService.getTitle()
      this.titleService.setTitle(
        `[${this.currentEnvironment.toUpperCase()}] - ${currentDocumentTitle}`
      )
      document.body.classList.add('has-env-banner')
    }
  }
}
